import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/common/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageLoader } from '@/components/common/PageLoader';

function LazyPage({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

// Trading Workbench — the qfinpricer instrument/trading workbench ported into qiyas,
// adapted to qiyas's own canonical `instrument` master (catalog) + canonical detail.
// Booking (Step 2) + Pricer/Risk wire up in Moves 2–3.
const TradingWorkbenchPage = lazy(() => import('@/modules/instruments/workbench/InstrumentsWorkbenchPage'));

export default function TradingWorkbenchRoutes() {
  return (
    <>
      <Route path="/trading/workbench" element={<ProtectedRoute><MainLayout><LazyPage><TradingWorkbenchPage /></LazyPage></MainLayout></ProtectedRoute>} />
      <Route path="/instruments/workbench" element={<ProtectedRoute><MainLayout><LazyPage><TradingWorkbenchPage /></LazyPage></MainLayout></ProtectedRoute>} />
    </>
  );
}
